import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface IState {
  visibleType: any;
  singleStationData: any;
  singlePathData: any;
  singleSurvayData: any;
}

const initialState: IState = {
  visibleType: "",

  singleStationData: [],
  singlePathData: [],
  singleSurvayData: [],
};

export const singleLocationSlice = createSlice({
  name: "singleLocation",
  initialState,
  reducers: {
    setStation: (state, action: PayloadAction<any>) => {
      return { ...state, singleStationData: action.payload, visibleType: "station" };
    },
    setPath: (state, action: PayloadAction<any>) => {
      return { ...state, singlePathData: action.payload, visibleType: "path" };
    },
    setSurvay: (state, action: PayloadAction<any>) => {
      return { ...state, singleSurvayData: action.payload, visibleType: "survay" };
    },
    clear: (state) => {
      return { ...state, visibleType: "", singleStationData: [], singlePathData: [], singleSurvayData: [] };
    },
  },
});

export const { setStation, setPath, setSurvay, clear } = singleLocationSlice.actions;

export default singleLocationSlice.reducer;
